import EditingBehaviorsBase from '../base/EditingBehaviors.base';
import type { EditingBehaviors } from '../schema';
import { IBuilderClass } from './builder.types';

class EditingBehaviorsBuilder
  extends EditingBehaviorsBase
  implements IBuilderClass<EditingBehaviors>
{
  constructor(editingBehaviors?: EditingBehaviors) {
    super(editingBehaviors);
  }

  public build() {
    const { errors, valid } = EditingBehaviorsBase.validate(this.editingBehaviors);

    if (!valid) {
      throw new Error(`Invalid manifest: ${JSON.stringify(errors)}`);
    }

    return this.editingBehaviors;
  }
}

export default EditingBehaviorsBuilder;
